<template>
  <section class="calendar-data-workspace hc-no-form-icons">
    <header class="calendar-data-workspace__toolbar">
      <nav class="calendar-data-workspace__modes" aria-label="Pilih tampilan data">
        <button
          v-for="mode in modes"
          :key="mode.value"
          type="button"
          :class="{ 'is-active': value === mode.value }"
          @click="selectMode(mode.value)">
          <i v-if="mode.icon" :class="mode.icon" aria-hidden="true"></i>
          <span>{{ mode.label }}</span>
        </button>
      </nav>

      <div v-if="$slots.filters || $slots.actions" class="calendar-data-workspace__controls hc-no-form-icons">
        <div v-if="$slots.filters" class="calendar-data-workspace__filters">
          <slot name="filters"></slot>
        </div>
        <div v-if="$slots.actions" class="calendar-data-workspace__actions">
          <slot name="actions"></slot>
        </div>
      </div>
    </header>

    <div class="calendar-data-workspace__content">
      <slot :mode="value"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "CalendarDataWorkspace",
  props: {
    value: { type: String, required: true },
    modes: {
      type: Array,
      default: () => [
        { value: "calendar", label: "Kalender", icon: "far fa-calendar-alt" },
        { value: "table", label: "Tabel", icon: "fas fa-table" },
      ],
    },
  },
  methods: {
    selectMode(mode) {
      if (mode === this.value) return
      this.$emit("input", mode)
      this.$emit("change", mode)
    },
  },
}
</script>

<style lang="scss" scoped>
.calendar-data-workspace {
  width: 100%;
}

.calendar-data-workspace__toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.8rem;
  padding: 0.7rem;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #f8fbfc;
}

.calendar-data-workspace__modes {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem;
  border-radius: 10px;
  background: #edf6f5;
}

.calendar-data-workspace__modes button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 112px;
  height: 38px;
  gap: 0.45rem;
  padding: 0 0.85rem;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  font-size: 0.82rem;
  font-weight: 600;
}

.calendar-data-workspace__modes button.is-active {
  background: #fff;
  color: #158d88;
  box-shadow: 0 3px 10px rgba(var(--skin-deep-rgb), 0.08);
}

.calendar-data-workspace__controls,
.calendar-data-workspace__filters,
.calendar-data-workspace__actions {
  display: flex;
  align-items: flex-end;
  gap: 0.65rem;
}

.calendar-data-workspace__controls {
  min-width: 0;
  flex: 1 1 auto;
  justify-content: flex-end;
}

.calendar-data-workspace__content {
  min-width: 0;
}

@media (max-width: 767.98px) {
  .calendar-data-workspace__toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .calendar-data-workspace__modes,
  .calendar-data-workspace__controls,
  .calendar-data-workspace__filters {
    width: 100%;
  }

  .calendar-data-workspace__modes button {
    min-width: 0;
    flex: 1 1 50%;
  }
}
</style>
